<template>
  <div style="position:sticky;top:0;z-index:2">
    <b-navbar
        toggleable="lg"
        type="dark"
        variant="info"
    >
      <b-navbar-toggle target="nav-collapse"/>
      <b-navbar-nav class="ml-auto search-contaier">
        <div class="d-flex">
          <router-link
              :to="{name:'shoppingcart'}"
              class="order-1 mr-auto"
          >
            <div
                id="shopcard2"
                class="xs-card"
            >
              <span
                  v-if="cart.length"
                  class="count"
              >{{ cart.length }}</span>
              <font icon="shopping-cart"/>
            </div>
          </router-link>
          <b-navbar-brand to="/">
            <img
                fluid
                class="nav-logo"
                :src="logo"
            >
          </b-navbar-brand>
          <!-- <b-navbar-brand to="/">
            <b-img height="50" fluid src="https://offers-jo.easysooq.net/images/logo/fav.png"></b-img>
          </b-navbar-brand> -->
        </div>
      </b-navbar-nav>


      <b-navbar-nav class="ml-auto search-container d-none d-sm-block">
        <b-nav-form class="search-box">
          <b-form-input
              size="sm"
              class="mr-sm-2"
              placeholder="ابحث عما تريد"
          />
          <font
              icon="search"
              class="search-box"
          />
        </b-nav-form>
      </b-navbar-nav>
      <!-- <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ml-auto search-container">
        <b-nav-form class="search-box">
          <b-form-input size="sm" class="mr-sm-2" placeholder="ابحث عما تريد"></b-form-input>
          <font icon="search" class="search-box"/>
        </b-nav-form>
      </b-navbar-nav>
    </b-collapse> -->

      <b-collapse
          id="nav-collapse"
          is-nav
          class="lg-card"
      >
        <b-navbar-nav class="ml-auto">
          <router-link :to="{name:'shoppingcart'}">
            <b-row
                id="shopcard"
                class="card-box d-none d-sm-flex"
            >
              <b-col
                  cols="3"
                  class="card-icon"
              >
                <font icon="shopping-cart"/>
              </b-col>
              <b-col
                  cols="9"
                  class="content "
              >
                <div>
                  سلة المشتريات
                </div>
                <div>
                  {{ cart.length }} منتج - {{ priceOfCart }} دينار
                </div>
              </b-col>
            </b-row>
          </router-link>
        </b-navbar-nav>
      </b-collapse>
      <!--mobile nav bar-->
      <b-collapse
          id="nav-collapse"
          class="sub-nav d-sm-none m-0"
          style="height:0"
          is-nav
      >
        <b-navbar-nav>
          <b-nav-item
              v-for="cat in categories"
              :key="cat.id"
              class="d-sm-none"
              :to="{name:'Category', params:{id:cat.id}}"
          >
            {{ cat.cat_name }}
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>

      <!--desktop nav bar-->
    </b-navbar>
    <!--slider-->
    <div
        class="slider-container d-none d-sm-block"
        @mouseenter="mouseIsOver = true"
        @mouseleave="mouseIsOver = false"
    >
      <b-container>
        <div>
          <swiper
              ref="mySwiper"
              class="pb-1"
              :options="swiperOptions"
          >
            <swiper-slide
                v-for="cat in categories"
                :key="cat.cat_icon_path"
            >
              <b-nav-item
                  class="text-center"
                  :class="{'active': routeName == cat.cat_name}"
                  :to="{name:'Category', params:{id:cat.id}}"
              >
                {{ cat.cat_name }}
              </b-nav-item>
            </swiper-slide>

            <div
                slot="pagination"
                class="swiper-pagination"
            />
          </swiper>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script type="text/javascript">
import {mapState, mapActions} from "vuex"
import axios from "axios"
import {Swiper, SwiperSlide, directive, Autoplay} from 'vue-awesome-swiper'

Swiper.use([Autoplay]);
import 'swiper/swiper.min.css'
import {getStoreConfig} from "../../config";

export default {
  name: 'Navbar',
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      store: process.env.STORE,
      mouseIsOver: false,
      swiperOptions: {

        slidesPerView: 6,
        loop: true,
        autoplay: true,
        pagination: {
          el: '.swiper-pagination'
        },
        // Some Swiper option/callback...
      },
      categories: [],
      showSub: true,
      showSearch: false,
      scrolled: '',
      showNav: true,
      slideToNumber: 0,
      window: {
        width: 0,
        height: 0
      },
      logo: getStoreConfig().logo
    }
  },
  computed: {
    ...mapState(["cart"]),
    routeName() {
      return this.$route.params.name
    },
    priceOfCart() {
      if (this.cart) {
        let price = 0;
        for (let i of this.cart) {
          price += Number(i.selling_price)
        }
        return price
      }
    },
    swiper() {

      return this.$refs.mySwiper.$swiper
    }
  },
  watch: {

    'scrolled': function () {
      var vm = this
      if (this.window.width > 991 && this.scrolled) {

        setTimeout(function () {
          vm.showSub = false;
        }, 100);
      } else if (this.window.width > 991 && !this.scrolled) {
        setTimeout(function () {
          vm.showSub = true;
        }, 100);
      }
      if (this.window.width < 991 && this.scrolled) {
        setTimeout(function () {
          vm.showSearch = true;
        }, 100);
      } else if (this.window.width < 991 && !this.scrolled) {
        setTimeout(function () {
          vm.showSearch = false;
        }, 100);
      }
    }

  },
  created() {
    window.addEventListener('resize', this.handleResize);
    // window.addEventListener('scroll', this.handleScroll);
    this.handleResize();
    //this.swiper.slideTo(1, 100, false)

    //this.getCategories();
    setInterval(() => {
      if (this.slideToNumber > Object.keys(this.categories).length) {
        this.slideToNumber = 0
      }
      if (!this.mouseIsOver) {
        this.slideToNumber++
        this.swiper.slideTo(this.slideToNumber, 500, false)
      }

    }, 5000)
  },
  mounted() {
    this.getCategories();
    this.getCardItems();
    this.$refs.mySwiper.$swiper.slideTo(1, 500, false)
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapActions(["getCardItems"]),
    //get categories
    getCategories() {
      axios.get(`?action=get_categories`,)
          .then(res => {
            this.categories = res.data
          })
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    handleScroll() {
      this.scrolled = window.scrollY > 0;
    }
  },

}
</script>
<style media="screen">
@charset "UTF-8";

/*!
* animate.css -http://daneden.me/animate
* Version - 3.5.1
* Licensed under the MIT license - http://opensource.org/licenses/MIT
*
* Copyright (c) 2016 Daniel Eden
*/

.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.animated.infinite {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}

.animated.hinge {
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
}

.animated.flipOutX,
.animated.flipOutY,
.animated.bounceIn,
.animated.bounceOut {
  -webkit-animation-duration: .75s;
  animation-duration: .75s;
}

@-webkit-keyframes bounce {
  from, 20%, 53%, 80%, to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
    animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  40%, 43% {
    -webkit-animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
    animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
    -webkit-transform: translate3d(0, -30px, 0);
    transform: translate3d(0, -30px, 0);
  }

  70% {
    -webkit-animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
    animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
    -webkit-transform: translate3d(0, -15px, 0);
    transform: translate3d(0, -15px, 0);
  }

  90% {
    -webkit-transform: translate3d(0, -4px, 0);
    transform: translate3d(0, -4px, 0);
  }
}

@keyframes bounce {
  from, 20%, 53%, 80%, to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
    animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  40%, 43% {
    -webkit-animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
    animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
    -webkit-transform: translate3d(0, -30px, 0);
    transform: translate3d(0, -30px, 0);
  }

  70% {
    -webkit-animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
    animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
    -webkit-transform: translate3d(0, -15px, 0);
    transform: translate3d(0, -15px, 0);
  }

  90% {
    -webkit-transform: translate3d(0, -4px, 0);
    transform: translate3d(0, -4px, 0);
  }
}

.bounce {
  -webkit-animation-name: bounce;
  animation-name: bounce;
  -webkit-transform-origin: center bottom;
  transform-origin: center bottom;
}


</style>
